var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","background":"white"}},[_c('SummaryNew',{attrs:{"id":_vm.selectedIds,"domain":_vm.account_domain}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }